/** @format */

import { CommonModule } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';

@Component({
	selector: 'pdp-highlights',
	templateUrl: './highlights.component.html',
	styleUrl: './highlights.component.scss',
	imports: [CommonModule]
})
export class HighlightsComponent {
	@Input() items: string[] = [];

	constructor(@Inject(PLATFORM_ID) protected platformId: object) {}

	trackByFn(index: number, item: string): string {
		return index.toString() + item;
	}
}
